<template>
  <footer class="footer">
    <div class="container">
      <div class="columns">
        <div class="column socialcolumn">
          <a
            href="https://www.facebook.com/wildepracht/"
            target="_blank"
            class="footernav"
            ><b-icon icon="facebook"> </b-icon
          ></a>
          <a
            href="https://www.instagram.com/wildepracht/"
            target="_blank"
            class="footernav"
            ><b-icon icon="instagram"> </b-icon
          ></a>
        </div>
        <div class="column legalcolumn">
          <router-link to="/agb" class="footernav">AGB</router-link>
          <router-link to="/datenschutz" class="footernav"
            >Datenschutz</router-link
          >
          <router-link to="/impressum" class="footernav">Impressum</router-link>
        </div>
      </div>
    </div>
    <cookie />
  </footer>
</template>

<script>
import cookie from "@/components/cookie.vue";

export default {
  name: "Foot",
  components: {
    cookie
  }
};
</script>

<style lang="scss">
.footernav {
  color: $white;
  font-weight: 700;
  font-size: 1.1rem;
  padding: 1.2rem 0.5rem;
  margin: 0rem 0.7rem;
}
.footernav:last-child {
  margin-right: 0rem;
}
.footernav:first-child {
  margin-left: 0rem;
}
.footernav:hover,
.footernav.is-active {
  color: $white-ter;
}
.legalcolumn {
  text-align: right;
}
.socialcolumn .footernav {
  margin: 0rem 0.1625rem;
}
@media screen and (max-width: $desktop) {
  .legalcolumn,
  .socialcolumn {
    text-align: center;
  }
}
</style>
